import { useReducer, createContext } from 'react'

export const CrosscheckVerificationContext = createContext()

function setSession(state, payload) {
	return {
		...payload,
	}
}

const reducer = (state, action) => {
	switch (action.type) {
	case 'SET_SESSION':
		return setSession(state, action.payload)
	default:
		return state
	}
}

export const CrosscheckVerificationContextProvider = (props) => {
	const [state, dispatch] = useReducer(reducer, {})

	return (
		<CrosscheckVerificationContext.Provider value={[state, dispatch]}>
			{props.children}
		</CrosscheckVerificationContext.Provider>
	)
}
